import { GridTemplate } from './types';

export const getGridColumns = (gridTemplate: GridTemplate) => {
	const gridColumns: string[] = [];

	let gridColumnStart = 1;

	for (let i = 0; i < gridTemplate.length; i++) {
		const gridItem = gridTemplate[i];
		if (gridItem === 'gap') {
			gridColumnStart += 1;
		} else {
			const gridColumn = `${gridColumnStart} / span ${gridItem}`;
			gridColumns.push(gridColumn);
			gridColumnStart += parseInt(gridItem, 10);
		}
	}

	return gridColumns;
};

export const getGridColumnsCount = (gridTemplate: GridTemplate) => {
	return gridTemplate.reduce((acc, item) => {
		const columnSize = item === 'gap' ? 1 : parseInt(item, 10);

		return acc + columnSize;
	}, 0);
};
